<template>
	<c-dialog ref="dialog"  mode="slide" width="800" mask-close @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
            <c-input type="hidden" name="agreement_code" maxlength="50" disabled></c-input>
			<c-form-item label="协议名称" required>
				<c-input name="agreement_name" maxlength="50"></c-input>
			</c-form-item>
			<c-form-item label="协议内容" required>
                <c-editor name="content"></c-editor>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	data() {
		return {
			
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑平台协议' : '创建平台协议'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/legal_agreement/update':'/legal_agreement/save',
				rule: {
					agreement_code: '请输入协议代码',
                    agreement_name: '请输入协议名称',
                    content: '请输入协议内容'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>